import { stack } from 'd3-shape';
import { SeriesPoint as d3SeriesPoint } from 'd3-shape';

export interface Series<Datum, Key> extends Array<SeriesPoint<Datum>> {
    /**
     * Key of the series.
     */
    key: Key;
    /**
     * Index of the series in the series array returned by stack generator.
     */
    index: number;
}

export interface SeriesPoint<T> extends d3SeriesPoint<T> {
    key: string;
}

export function stackData<T>(
    data: T[],
    ...keys: (keyof T)[]
): Series<T, string>[] {
    const stacker = stack<T>().keys(keys as string[]);

    const stackedSeries = stacker(data) as Series<T, string>[];

    for (const series of stackedSeries) {
        const key = series.key;
        for (const item of series) {
            item.key = key;
        }
    }

    return stackedSeries;
}

export function getMax<T>(...stackedChartData: Series<T, string>[][]): number {
    const seriesMax = (series: Series<T, string>) =>
        Math.max(...series.map((point) => point[1]));

    return stackedChartData.reduce((value, series) => {
        return Math.max(...series.map(seriesMax), value);
    }, 0);
}

export function getMin<T>(...stackedChartData: Series<T, string>[][]): number {
    const seriesMin = (series: Series<T, string>) =>
        Math.min(...series.map((point) => point[1]));

    return stackedChartData.reduce((value, series) => {
        return Math.min(...series.map(seriesMin), value);
    }, 0);
}
